module.exports = __webpack_public_path__ + "img/medium_blonde.e4451f01.svg";